import { createStore } from "vuex";

function getNavigatorLanguage() {
  var language = navigator.language.substring(0, 2).toLowerCase();
  if(language == "ca") return "es_ct";
  return language; 
}

// Create a new store instance.
const store = createStore({
  state() {
    return {
      count: 0,
      locale: localStorage.getItem("locale") != null ? localStorage.getItem("locale") : getNavigatorLanguage(),
      logged: false,
      optico: "",
    };
  },
  mutations: {
    increment(state) {
      state.count++;
    },
  },
});

export default store;
